import { ProductStockStatus } from '@/fo/api/magento';
import { UiKitLabelBrand } from '@/fo/ui/kit/label/brand';
import { MappedProduct } from '@/fo/util/map-product-data';

export const productMock: MappedProduct = {
  sku: '123456',
  mindboxId: '1234',
  name: 'Масло для душа',
  nameEng: 'Shampoo',
  link: '/product/123456',
  stockQuantity: 100,
  effects: 'Увлажняющее',
  description: 'Увлажняющее масло для душа для всей семьи',
  characteristics: [],
  activeComponents: [],
  composition: 'Увлажняющее масло для душа для всей семьи',
  usageInstructions: 'Увлажняющее масло для душа для всей семьи',
  banners: [],
  firstLevelCategory: null,
  lastLevelCategory: null,
  labelsBrand: [],
  labelsBonus: [],
  labels: [],
  brand: 'Capybara',
  series: 'Atoderm',
  shortDescription: 'Увлажняющее масло для душа для всей семьи',
  baseImage: {
    src: 'https://dummyimage.com/400x400/003A70/FFFFFF?text=Capybara',
    alt: 'Масло для душа'
  },
  thumbnail: {
    src: 'https://dummyimage.com/400x400/003A70/FFFFFF?text=Capybara',
    alt: 'Масло для душа'
  },
  catalogBrandUrl: '/capybara',
  mediaGallery: [],
  currency: 'RUB',
  rating: 4.5,
  reviewCount: 100,
  bestRating: 5,
  worstRating: 1,
  stockStatus: ProductStockStatus.InStock,
  basePrice: 3199,
  finalPrice: 2600,
  configurableVariants: [
    {
      sku: '1',
      label: '1 л',
      stockStatus: ProductStockStatus.InStock,
      isSelected: true
    },
    {
      sku: '2',
      label: '200 мл',
      stockStatus: ProductStockStatus.InStock,
      isSelected: false
    },
    {
      sku: '3',
      label: '100 мл',
      stockStatus: ProductStockStatus.OutOfStock,
      isSelected: false
    }
  ],
  bonusPoints: 99,
  bonusPointsMax: 99
};

const labels = [
  {
    name: 'Capybara',
    color: '#003a70',
    url: '/capybara'
  },
  {
    name: 'Atoderm',
    color: '#0077cf',
    url: '/atoderm'
  }
];

export const labelsMock = labels.map(({ name, color, url }) => (
  <UiKitLabelBrand
    key={name}
    url={url}
    color={color}
  >
    {name}
  </UiKitLabelBrand>
));
